import type { FluxErrorEntityErrorCodes } from '../types.js';

export const FeatureFlagAccountErrorCodes = {
  FeatureFlagAccountAlreadyExists: {
    code: 'feature-flag-account/already-exists',
    message: 'A conta já possui esta funcionalidade ativada.',
    explanation: 'A funcionalidade que você está tentando ativar para esta conta já está ativada.',
    localizations: {},
  },
  FeatureFlagAccountNotFound: {
    code: 'feature-flag-account/not-found',
    message: 'A funcionalidade não está ativada para esta conta.',
    explanation: 'A funcionalidade que você está tentando acessar não está ativada para esta conta.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'feature-flag-account'>;

export const FeatureFlagErrorCodes = {
  FeatureFlagAlreadyDisabled: {
    code: 'feature-flag/already-disabled',
    message: 'Esta funcionalidade já está desativada.',
    explanation: 'A funcionalidade que você está tentando desativar já está desativada.',
    localizations: {},
  },
  FeatureFlagAlreadyEnabled: {
    code: 'feature-flag/already-enabled',
    message: 'Esta funcionalidade já está ativada.',
    explanation: 'A funcionalidade que você está tentando ativar já está ativada.',
    localizations: {},
  },
  FeatureFlagAlreadyWhitelistOnly: {
    code: 'feature-flag/already-whitelist-only',
    message: 'A funcionalidade já está restrita a uma lista específica.',
    explanation: 'A funcionalidade que você está tentando configurar para apenas whitelist já está configurada dessa forma.',
    localizations: {},
  },
  FeatureFlagForbidden: {
    code: 'feature-flag/forbidden',
    message: 'Essa funcionalidade está em testes e não está disponível publicamente.',
    explanation: 'Essa funcionalidade está em fase de testes e não está disponível publicamente.',
    localizations: {},
  },
  FeatureFlagInative: {
    code: 'feature-flag/inactive',
    message: 'Esta funcionalidade não está disponível no momento.',
    explanation: 'A funcionalidade que você está tentando acessar está inativa.',
    localizations: {},
  },
  FeatureFlagInvalidSlug: {
    code: 'feature-flag/invalid-slug',
    message: 'O identificador da funcionalidade é inválido.',
    explanation: 'O slug da funcionalidade é inválido. Verifique se o identificador está correto.',
    localizations: {},
  },
  FeatureFlagNotFound: {
    code: 'feature-flag/not-found',
    message: 'A funcionalidade solicitada não foi encontrada.',
    explanation: 'A funcionalidade que você está tentando acessar não foi encontrada.',
    localizations: {},
  },
  FeatureFlagNotWhitelistOnly: {
    code: 'feature-flag/not-whitelist-only',
    message: 'A funcionalidade não está configurada para lista restrita.',
    explanation: 'A funcionalidade que você está tentando acessar não está configurada para apenas whitelist.',
    localizations: {},
  },
} as const satisfies FluxErrorEntityErrorCodes<'feature-flag'>;
